import useGetComicsDetail from "@/api/hooks/useComicsDetail"
import useSearchEducation from "@/api/hooks/useSearchEducation"
import SEO from "@/components/core/SEO"
import BonusQuestionSectionWrapper from "@/components/pages/CartoonDetailPage/BonusQuestionSection/BonusQuestionSectionWrapper"
import CartoonDetailSection from "@/components/pages/CartoonDetailPage/CartoonDetailSection"
import GameSection from "@/components/pages/CartoonDetailPage/GameSection"
import Container from "@/components/shared/Container"
import LoadingSpinner from "@/components/shared/LoadingSpinner/LoadingSpinner"
import Typography from "@/components/shared/Typography"
import { useParams, useSearchParams } from "next/navigation"
import { useEffect, useState } from "react"

const CartoonDetailPageMain = () => {
  const params = useParams()
  const searchParams = useSearchParams()

  const sectionFromParams = searchParams.get("section")

  const comicsSlug = params.slug

  const { comicsDetail, isLoading } = useGetComicsDetail(String(comicsSlug))

  const { educationList } = useSearchEducation({ educationIds: comicsDetail?.educationIds || [] })

  enum SECTION {
    MAIN,
    GAME,
    LOCATION,
    BONUS_QUESTION,
  }

  const [section, setSection] = useState<SECTION>(SECTION.MAIN)

  useEffect(() => {
    if (sectionFromParams === "game") {
      setSection(SECTION.GAME)
    } else if (sectionFromParams === "bonus") {
      setSection(SECTION.BONUS_QUESTION)
    } else if (sectionFromParams === "location") {
      setSection(SECTION.LOCATION)
    } else {
      setSection(SECTION.MAIN)
    }
  }, [SECTION.BONUS_QUESTION, SECTION.GAME, SECTION.LOCATION, SECTION.MAIN, sectionFromParams])

  if (isLoading)
    return (
      <Container className=" inset-0 flex items-center justify-center py-[300px]">
        <SEO />
        <LoadingSpinner />
      </Container>
    )

  if (!comicsDetail || !educationList) {
    return (
      <Typography type="h1" className="mx-auto px-3 py-[200px] text-center">
        <SEO />
        Komiks nenalezen
      </Typography>
    )
  }

  return (
    <>
      <SEO title={comicsDetail.name} description={comicsDetail.description} />
      {section === SECTION.MAIN && (
        <CartoonDetailSection
          cartoonData={comicsDetail}
          educationList={educationList.content}
          comicsSlug={String(comicsSlug)}
        />
      )}
      {section === SECTION.GAME && <GameSection />}
      {section === SECTION.BONUS_QUESTION && (
        <BonusQuestionSectionWrapper
          bonusQuestionId={comicsDetail?.bonusQuestion.bonusQuestionId || ""}
          comicsBackgroundImageUrl={comicsDetail?.backgroundImageUrl || ""}
          comicsName={comicsDetail?.name || ""}
          comicsSlug={String(comicsSlug)}
        />
      )}
    </>
  )
}

export default CartoonDetailPageMain
